import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Features from './pages/Features/Features';
import Demo from './pages/Demo/Demo';
import Legal from './pages/Legal/Legal';
import NotFound from './pages/NotFound/NotFound';

export default function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/features" element={<Features />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/privacy" element={<Legal doc="privacy" />} />
                <Route path="/terms" element={<Legal doc="terms" />} />
                <Route path="/data-deletion" element={<Legal doc="deletion" />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}